import { render, staticRenderFns } from "./ProductoAlmacenKardex.vue?vue&type=template&id=b709618e&scoped=true&"
import script from "./ProductoAlmacenKardex.vue?vue&type=script&lang=js&"
export * from "./ProductoAlmacenKardex.vue?vue&type=script&lang=js&"
import style0 from "./ProductoAlmacenKardex.vue?vue&type=style&index=0&id=b709618e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b709618e",
  null
  
)

export default component.exports